import { PencilSquareIcon } from "@heroicons/react/24/solid";

const EditOutlineButton = ({
  buttonText = "Edit",
  className = "",
  onClick,
  disabled = false,
}) => {
  return (
    <button
      value={buttonText}
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? "cursor-not-allowed border text-quaternary opacity-50 border-quaternary "
          : "text-quaternary border-quaternary") +
        `  ${className}  flex items-center  w-fit justify-items-center hover:scale-90 
         bg-tranparent  border-quaternary shadow-md hover:bg-quaternary text-quaternary group
          relative py-1 px-4 border text-xs font-medium rounded-full hover:text-white
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary 
          focus:ring-opacity-70`
      }
    >
      <PencilSquareIcon className="h-4 w-4 mr-2" />
      <div>{buttonText}</div>
    </button>
  );
};
export default EditOutlineButton;
